export const COMPLETE_EDITION_COVER =
  'https://cdn.magicpatterns.com/uploads/8iTMevrqiSnw8dode2jSfA/01_complete_edition_cover.png'

/** Anchor used by every CTA that jumps to the offer section. */
export const CHECKOUT_URL = '#offer'

/** Real payment destination, used by the primary CTA in the offer card. */
export const PAYMENT_URL = 'https://math-made-ready.impultienda.ar/checkout'

export const offerChecklist: string[] = [
  '200+ pixel math exercises',
  '27 activity pages',
  'Three grade-focused math volumes',
  'Grades 1–5 coverage',
  'Answer keys included',
  'Bonus Pack with printable progress tools',
  'Instant digital access',
  'Print at home or school',
]

export const startSteps = [
  {
    id: 'access',
    index: '01',
    title: 'Get access',
    copy: 'Complete your secure purchase.',
  },
  {
    id: 'open',
    index: '02',
    title: 'Open your materials',
    copy: 'Access the complete digital edition right away.',
  },
  {
    id: 'print',
    index: '03',
    title: 'Print and start',
    copy: 'Choose a challenge and begin the next mission.',
  },
]
